var CACHE = new Map();
export var accessPromise = function (fn, key) {
    if (CACHE.get(key)) {
        return CACHE.get(key);
    }
    var promise = fn();
    var promiseLikeObj = {
        promise: promise,
        isPending: true,
        isFulfilled: false
    };
    promise
        .then(function (res) {
        promiseLikeObj.isPending = false;
        promiseLikeObj.result = res;
    })
        .catch(function (err) {
        promiseLikeObj.isPending = false;
        promiseLikeObj.error = err;
    });
    CACHE.set(key, promiseLikeObj);
    return promiseLikeObj;
};
export var waitPromiseLike = function (obj) {
    if (obj.isPending) {
        throw obj.promise;
    }
    else if (obj.error) {
        throw obj.error;
    }
    return obj.result;
};
